import styled from "styled-components/macro";

export const DivDeckContainer = styled.div<{ width: number }>`
  width: ${(props) => props.width}rem;
  background-color: var(--black);
`;
